import { isEmpty } from "lodash";
import React from "react";
import Draggable from "react-draggable";
import { useSelector } from "react-redux";

const QueryViewModal = ({ onCancel, viewData }) => {
    const renderFilters = filters => {
        return (
            <>
                {filters && (
                    <>
                        {Object.values(filters)
                            .filter(f => f.name !== "Years")
                            .map(
                                f =>
                                    f?.value?.length > 0 && (
                                        <React.Fragment key={f.name}>
                                            <span className="tag active" style={{ textTransform: "capitalize" }}>
                                                {f.name}{" "}
                                            </span>
                                            {f.value.map(item => (
                                                <span key={item} className="tag">
                                                    {item}
                                                </span>
                                            ))}
                                            <br />
                                        </React.Fragment>
                                    )
                            )}

                        {Object.values(filters)
                            .filter(f => f.name === "Years")
                            .map(f =>
                                f?.value ? (
                                    <React.Fragment key={f.name}>
                                        <span className="tag active" style={{ textTransform: "capitalize" }}>
                                            {f.name}{" "}
                                        </span>
                                        <span className="tag">Start: {f.value.start}</span>
                                        <span className="tag">End: {f.value.end}</span>
                                        <br />
                                    </React.Fragment>
                                ) : null
                            )}
                    </>
                )}
            </>
        );
    };

    const getAppliedFilters = () => {
        const filterNames = [];

        if (!viewData) return filterNames;

        Object.entries(viewData).forEach(([key, value]) => {
            if (key === "exclude_filters") {
                Object.entries(value).forEach(([excludeKey, excludeVal]) => {
                    if (excludeVal?.length) {
                        filterNames.push({
                            name: `exclude: ${excludeKey}`,
                            value: excludeVal
                        });
                    }
                });
            } else if (key === "filters" && !isEmpty(value)) {
                Object.entries(value).forEach(([fKey, fValue]) => {
                    if (fValue?.key?.from != null && fValue?.key?.to != null) {
                        const label = `${fValue?.viewData?.[0] || fKey}: ${fValue.key.from} - ${fValue.key.to}`;
                        filterNames.push({
                            name: fKey,
                            value: [label]
                        });
                    } else {
                        filterNames.push({
                            name: fKey,
                            value: [`${fValue.key || ""} [${fValue.filters?.join(", ")}]`]
                        });
                    }
                });
            } else if (key === "top_n" && !isEmpty(value)) {
                Object.entries(value).forEach(([tKey, tValue]) => {
                    filterNames.push({
                        name: tKey,
                        value: [`${tValue} [Top N]`]
                    });
                });
            } else if (key === "start_year" || key === "end_year") {
            } else if (Array.isArray(value) && value.length) {
                filterNames.push({
                    name: key,
                    value
                });
            } else if ((typeof value === "string" || typeof value === "number") && key !== "update_fci") {
                filterNames.push({
                    name: key,
                    value: [value]
                });
            }
        });

        if (viewData.start_year || viewData.end_year) {
            filterNames.push({
                name: "Years",
                value: {
                    start: viewData.start_year || "",
                    end: viewData.end_year || ""
                }
            });
        }

        return filterNames;
    };

    return (
        <React.Fragment>
            <div
                className="modal modal-region modal-view modal-applied-filter modal-query-filt"
                id="modalId"
                style={{ display: "block" }}
                tabIndex="-1"
            >
                <Draggable handle=".draggable" cancel=".not-draggable">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header draggable">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    <div className="txt-hed">Details </div>
                                </h5>
                                <button type="button" className="close not-draggable" onClick={onCancel}>
                                    <span aria-hidden="true">
                                        <img src="/img/close.svg" alt="" />
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body region-otr filter-apply">
                                <>
                                    <div className="fil-badge-otr">
                                        <div className="tag-ara">
                                            <div className={"tag-scrol"}>{renderFilters(getAppliedFilters(viewData))}</div>
                                        </div>
                                    </div>
                                </>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
        </React.Fragment>
    );
};

export default QueryViewModal;
